import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import DstButton from "../../components/DstButton/DstButton";
import DstCertifications from "../../components/DstCertifications/DstCertifications";
import DstFooter from "../../components/DstFooter/DstFooter";
import DstNavbar from "../../components/DstNavbar/DstNavbar";
import DstProgram from "../../components/DstProgram/DstProgram";
import HeaderContent from "../../components/HeaderContent/HeaderContent";
import HubspotForm from "../../components/HubspotForm/HubspotForm";
import InfoCard from "../../components/InfoCard/InfoCard";
import Popup from "../../components/Popup/Popup";
import PreFooterOmnes from "../../components/PreFooterOmnes/PreFooterOmnes";
import Title from "../../components/DstTitle/DstTitle";
import { ContactSection } from "./Formation.component";

type ProgramItem = { img: string; title: string };
type Certification = { content: string };
type Props = {
  category: string;
  certifications?: Certification[];
  description: React.ReactNode;
  duration: number;
  formId: string;
  image: string;
  popupFormId?: string;
  program: ProgramItem[];
  title: string;
  titleColor: string;
};

const FormationBuilderPage = ({
  category,
  certifications,
  description,
  duration,
  formId,
  image,
  popupFormId = formId,
  program,
  title,
  titleColor,
}: Props) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <React.Fragment>
      <DstNavbar />
      <HeaderContent
        alt={category}
        image={image}
        title={
          <h1 className="fw-normal">
            Formez vos futurs collaborateurs au secteur {category} en tant que{" "}
            <span className="fw-black" style={{ color: titleColor }}>
              {title}
            </span>
          </h1>
        }
        content={<div className="mt-3">{description}</div>}
        dstButton={{
          value: "J’envoie mon cv",
          clickFunction: () => setShowModal(true),
        }}
      />
      <Container className="my-3 my-md-5">
        <Title text={category} center underlineWidth={60} textUppercase />
        <Title
          text="Le cursus"
          tag="h2"
          className="h3"
          color="#2424FF"
          underlineWidth={10}
          textUppercase
        />
        <DstProgram
          title={
            <React.Fragment>
              Découvrez notre formation en{" "}
              <span className="fw-black" style={{ color: titleColor }}>
                {title}
              </span>
            </React.Fragment>
          }
          items={program}
          dstButton={{
            value: "J’envoie mon cv",
            clickFunction: () => setShowModal(true),
          }}
        />
        {certifications && (
          <Container>
            <DstCertifications
              dstButton={{
                value: "Je suis intéressé.e",
                clickFunction: () => setShowModal(true),
                disableAnimation: true,
              }}
              certifications={certifications}
            />
          </Container>
        )}
      </Container>
      <div className="dark-background white-font py-3 py-md-5">
        <Container className="my-3 my-md-5">
          <Title
            text="Recrutement"
            className="h3"
            tag="h2"
            color="#20FFA4"
            underlineColor="#9D9FAB"
            textUppercase
          />
          <h3 className="h2 mb-3 mb-md-5">
            Comment s’organise le{" "}
            <span className="green-font">recrutement</span>
          </h3>
          <Row>
            <InfoCard
              title="Définition du besoin"
              text="Liora identifie les besoins spécifiques des entreprises et détermine les profils à sourcer, ainsi que la formation adaptée à ces profils."
              imageSrc="/assets/images/icon/write.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Sourcing"
              text="En accord avec les critères de sélection, Liora identifie et sélectionne les profils les plus proches des besoins spécifiques de l’entreprise. Ces profils bénéficieront d’une formation ciblée pour combler leurs lacunes."
              imageSrc="/assets/images/icon/light.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Formation"
              text={`Une fois les profils sélectionnés et validés par l’entreprise, ils entament une formation intensive de ${duration} semaines. À l’issue de cette formation, ils seront pleinement qualifiés et certifiés, prêts à répondre aux besoins de l’entreprise.`}
              imageSrc="/assets/images/icon/book.svg"
              borderColor="#F7F7F7"
            />
            <InfoCard
              title="Validation et embauche"
              text="La validation de la formation, et donc de l’embauche, est soumise à une soutenance à laquelle les équipes de l’entreprise sont invitées à assister. La décision finale d’embauche repose entièrement entre les mains de l’entreprise cliente."
              imageSrc="/assets/images/icon/work.svg"
              borderColor="#F7F7F7"
            />
          </Row>
          <div className="text-center">
            <DstButton
              value="télécharger la brochure"
              btnClass="m-bold"
              clickFunction={() => setShowModal(true)}
            />
          </div>
        </Container>
      </div>
      <Container className="mt-3 mt-md-5">
        <ContactSection portalId="19831339" formId={formId} />
      </Container>
      <PreFooterOmnes />
      <DstFooter />
      <Popup
        show={showModal}
        onClose={() => setShowModal(false)}
        modalTitle={`Formation ${title}`}
      >
        <HubspotForm portalId="19831339" formId={popupFormId} />
      </Popup>
    </React.Fragment>
  );
};

export default FormationBuilderPage;
